import $script from 'scriptjs';

import Forms from '../Forms';
import layout from '../Layout';

import AnnouncementBar from '#components/AnnouncementBar';
import HeaderSearch from '#components/HeaderSearch';
import NavDesktop from '#components/NavDesktop';
import NavMobile from '#components/NavMobile';

import { cdfQuantityTotal, checkIfCartsEmpty, clearCart } from '#helpers';

export default class StaticSectionHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data.settings;
    this.postMessage = section.postMessage;
    this.headerSearch = null;

    this.$scripts = $('[data-scripts]');

    this.$menuToggle = this.$el.find('[data-menu-toggle]');
    this.$cartCount = this.$el.find('[data-header-cart-count]');
    this.$searchField = this.$el.find('[data-live-search]');

    this.$siteNavigation = this.$el.find('[data-site-navigation]');
    this.$desktopNavigation = this.$siteNavigation.find('ul.navmenu-depth-1');
    this.$headerTools = this.$siteNavigation.find('[data-header-actions]');

    this.$accountMenuToggle = this.$el.find('[data-account-menu-toggle]');
    this.$accountMenu = this.$el.find('[data-account-menu]');
    this.$accountMenuLogout = this.$el.find('[data-account-menu-logout]');

    this.announcementBar = new AnnouncementBar({
      $el: this.$el,
      $toggle: this.$menuToggle
    });

    this.navMobile = new NavMobile({
      $el: this.$el,
      $toggleOpen: this.$menuToggle
    });

    this.navDesktop = new NavDesktop({
      $el: this.$siteNavigation,
      postMessage: this.postMessage
    });

    this.forms = new Forms(this.$el);

    $script(this.$scripts.data('shopify-api-url'), () => {
      this.headerSearch = new HeaderSearch(
        {
          $el: this.$searchField,
          $header: this.$el
        },
        this.settings.live_search
      );
    });

    // Handle Accordion interaction when window size changes
    this._headerToolsSize = this._headerToolsSize.bind(this);
    layout.onBreakpointChange(this._headerToolsSize);

    this.$el.on('cartcount:update', (event, data) => {
      const cdfCount = cdfQuantityTotal(data.response);
      const cartTotal = data.response.item_count - cdfCount;

      this.$cartCount
        .attr('data-header-cart-count', cartTotal)
        .toggleClass('visible', cartTotal > 0);
    });

    this._headerToolsSize();

    this.events = [
      // Toggle account menu
      this.$accountMenuToggle.on('click.header', event => {
        event.stopPropagation();
        this._toggleAccountMenu();
      }),

      // Toggle logout account menu
      this.$accountMenuLogout.on('click.header', event => {
        checkIfCartsEmpty(clearCart());
      }),

      // Close account menu when clicking outside
      $(document).on('click.header', event => {
        this._closeAccountMenu(event.target);
      })
    ];
  }

  onSectionDeselect() {
    this.navDesktop.closeAll(null);
  }

  onSectionUnload() {
    this.announcementBar.unload();
    this.navMobile.unload();
    this.navDesktop.unload();
    this.forms.unload();

    this.$el.off('cartcount:update');

    this.headerSearch.unload();

    this.$accountMenuToggle.off('click.header');
  }

  onSectionMessage(name, data) {
    if (name === 'nav:close-all' && layout.isBreakpoint('L')) {
      this.navDesktop.closeAll(null);
    }
  }

  onSectionBlockSelect(block) {
    if (layout.isBreakpoint('L')) {
      setTimeout(() => {
        if (!$(block.el).find('.navmenu-link').hasClass('navmenu-active')) {
          this.navDesktop.toggleItem(block.el);
        }
      }, 100);
    }
  }

  onSectionBlockDeselect() {
    this.navDesktop.closeAll(null);
  }

  _toggleAccountMenu() {
    this.$accountMenuToggle.attr(
      'aria-expanded',
      this.$accountMenuToggle.attr('aria-expanded') == 'false'
        ? 'true'
        : 'false'
    );
    this.$accountMenuToggle.toggleClass('active');
    this.$accountMenu.revealer('toggle');
  }

  _closeAccountMenu(target) {
    if (!$(target).closest(this.$accountMenuToggle).length) {
      this.$accountMenuToggle.attr('aria-expanded', false);
      this.$accountMenuToggle.removeClass('active');
      this.$accountMenu.revealer('hide');
    }
  }

  _headerToolsSize() {
    if (!layout.isBreakpoint('L')) {
      return;
    }

    const outerWidth = this.$headerTools.width();
    const innerWidths = [];

    this.$headerTools.find('li').each((index, el) => {
      innerWidths.push(Math.ceil($(el).outerWidth()));
    });

    const combinedWidths = innerWidths.reduce((a, b) => a + b, 0);

    if (combinedWidths > outerWidth) {
      this.$headerTools.css('max-width', `${combinedWidths}px`);
      this.$desktopNavigation.css(
        'max-width',
        `calc(100% - ${combinedWidths}px)`
      );
    }
  }
}
